import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

export class WishlistList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.renderWishlist();

    // 监听 wishlist 更新事件
    document.addEventListener(
      ThemeEvents.wishlistUpdate || 'wishlist:update',
      this.handleWishlistUpdate
    );
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      ThemeEvents.wishlistUpdate || 'wishlist:update',
      this.handleWishlistUpdate
    );
  }

  handleWishlistUpdate = () => {
    this.renderWishlist();
  };

  getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('wishlist') || '[]');
    } catch {
      return [];
    }
  }

  async renderWishlist() {
    const wishlist = this.getWishlist();

    if (wishlist.length === 0) {
      this.innerHTML = `
        <div class="wishlist-empty">
          <p>Your wishlist is empty.</p>
          <a href="/collections/all" class="wishlist-return-btn">Continue shopping</a>
        </div>
      `;
      return;
    }

    const query = wishlist.map((id) => `id:${id}`).join(' OR ');
    const url = `/search?view=card&type=product&q=${encodeURIComponent(query)}`;

    try {
      const response = await fetch(url);
      const html = await response.text();

      // ✅ 用 DOMParser 提取 id="ResultsList" 部分
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const results = doc.querySelector('#ResultsList');

      if (results) {
        this.innerHTML = results.outerHTML;
      } else {
        console.warn('No #ResultsList found in fetched HTML');
        this.innerHTML = `<p>Failed to locate ResultsList.</p>`;
      }
    } catch (err) {
      console.error('Wishlist fetch failed:', err);
      this.innerHTML = `<p>Failed to load wishlist items.</p>`;
    }
  }
}

if (!customElements.get('wishlist-list')) {
  customElements.define('wishlist-list', WishlistList);
}
